import React, { useContext } from "react";
import {
  Box,
  Flex,
  Heading,
  SimpleGrid,
  Spacer,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Text,
} from "@chakra-ui/react";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import { PersonIcon } from "components/Icons/Icons";
import IconBox from "components/Icons/IconBox";
import medusa from "assets/img/cardimgfree.png";
import { UserContext } from "context/user.context";

export default function Dashboard() {
  const [user] = useContext(UserContext);
  // console.log(user)
  return (
    <Box>
      <Heading textAlign={"center"} mb={"10"} color={"blue.800"}>
        PCARI GIGS ADMIN DASHBOARD
      </Heading>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="24px">
        <Card minH="83px">
          <CardBody>
            <Flex flexDirection="row" align="center" justify="center" w="100%">
              <Stat me="auto">
                <StatLabel fontSize="sm" color="gray.400" fontWeight="bold" pb="2px">
                  Total Users
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color="#fff">
                    1,600
                  </StatNumber>
                  <StatHelpText
                    alignSelf="flex-end"
                    justifySelf="flex-end"
                    m="0px"
                    color="green.400"
                    fontWeight="bold"
                    ps="3px"
                    fontSize="md"
                  >
                    +5%
                  </StatHelpText>
                </Flex>
              </Stat>
              <IconBox as="div" h={"45px"} w={"45px"} bg="brand.200">
                <PersonIcon h={"24px"} w={"24px"} color="#fff" />
              </IconBox>
            </Flex>
          </CardBody>
        </Card>
        <Card
          p="0px"
          gridArea={{ md: "1 / 1 / 2 / 3", "2xl": "auto" }}
          bgImage={medusa}
          bgSize="cover"
          bgPosition="50%"
        >
          <CardBody w="100%" h="100%">
            <Flex flexDirection={{ sm: "column", lg: "row" }} w="100%" h="100%">
              <Flex flexDirection="column" h="100%" p="22px" minW="60%" lineHeight="1.6">
                <Text fontSize="sm" color="gray.400" fontWeight="bold">
                  Welcome back,
                </Text>
                <Text fontSize="28px" color="#fff" fontWeight="bold" mb="18px">
                  {user?.user?.username}
                </Text>
                <Text fontSize="md" color="gray.400" fontWeight="normal" mb="auto">
                  Glad to see you again! <br />
                  Ask me anything.
                </Text>
                <Spacer />
                {/* <Flex align="center">
                  <Button
                    p="0px"
                    variant="no-hover"
                    bg="transparent"
                    my={{ sm: "1.5rem", lg: "0px" }}
                  >
                    <Text
                      fontSize="sm"
                      color="#fff"
                      fontWeight="bold"
                      cursor="pointer"
                      transition="all .3s ease"
                      my={{ sm: "1.5rem", lg: "0px" }}
                      _hover={{ me: "4px" }}
                    >
                      Tab to record
                    </Text>
                    <Icon
                      as={BsArrowRight}
                      w="20px"
                      h="20px"
                      color="#fff"
                      fontSize="2xl"
                      transition="all .3s ease"
                      mx=".3rem"
                      cursor="pointer"
                      pt="4px"
                      _hover={{ transform: "translateX(20%)" }}
                    />
                  </Button>
                </Flex> */}
              </Flex>
            </Flex>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Box>
  );
}
